<template>
   <div>
      <Navbar />
      <!-- <Alert></Alert> -->
      <!-- <div class="container-fluid custom-top"> -->
         <!-- <div class="row"> -->
            <main role="main" class="container">
              <!-- <main role="main" class="col-md-9 ml-sm-auto col-lg-10 px-4"> -->
               <router-view></router-view>
            </main>
         <!-- </div> -->
      <!-- </div> -->
   </div>
</template>

<script>
import Sidebar from  "./Sidebar";
import Navbar from "./Navbar";
import Alert from "./AlertMessage";
import CustomerOrders from "./pages/CustomerOrders"

export default {
   components: {
      // Sidebar,
      Navbar,
      Alert,
      CustomerOrders
   }
};
</script>

<style lang="scss" scoped>
.custom-top {
   margin-top: 1px;
   @media (min-width: 767px) {
      margin-top: 48px;
   }
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue